import { render, staticRenderFns } from "./speed-limit-rules.vue?vue&type=template&id=47e7f31e&"
import script from "./speed-limit-rules.vue?vue&type=script&lang=js&"
export * from "./speed-limit-rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports